import { render } from "./BenefitList.vue?vue&type=template&id=fcbaf472&scoped=true"
import script from "./BenefitList.vue?vue&type=script&lang=js"
export * from "./BenefitList.vue?vue&type=script&lang=js"

import "./BenefitList.vue?vue&type=style&index=0&id=fcbaf472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcbaf472"]])

export default __exports__